<template>
  <div class="RealisationList">
    <TableManager
      v-show="mainRoute"
      ref="TableManager"
      class="mx-3"
      :loading="loading"
      :source-records="records"
      :category="tableCategory"
      :uuid="tableUuid"
    />

    <div
      v-if="mainRoute"
      class="mt-3 text-center"
    >
      <div v-if="! loading">
        <router-link
          v-if="lastOpenedRecord"
          class="text-muted"
          :to="{ name: 'Realisation', params: { uuid: lastOpenedRecord } }"
        >
          <b-icon
            icon="arrow-left-circle"
            class="mr-1"
          />
          Ga terug naar het laatst geopende realisatie proces
        </router-link>

        <div class="text-muted mt-2">
          Laatst bijgewerkt om {{ lastRefresh }}
        </div>
        <!-- <b-link
          class="text-muted"
          @click="handleRefresh"
        >
          <b-icon
            icon="arrow-repeat"
            class="mr-1"
          />
          Nu bijwerken
        </b-link> -->
      </div>
      <div v-else>
        <div v-if="failed">
          <b-alart
            :show="true"
            variant="danger"
          >
            Niet alles kon in 1 keer goed ingeladen worden.
          </b-alart>
          <!-- <b-link
            class="text-muted"
            @click="handleRefresh"
          >
            <b-icon
              icon="arrow-repeat"
              class="mr-1"
            />
            Probeer opnieuw
          </b-link> -->
        </div>
        <div v-else>
          Bezig met verversen...
        </div>
      </div>
    </div>

    <router-view
      v-if="! mainRoute"
      :key="$route.path"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

import TableManager from '@/components/Table/TableManager'

import { municipalityOptions } from '@/config'

export default {
  name: 'RealisationList',
  components: {
    TableManager,
  },
  data() {
    return {
      // TODO: The loading indicator function has been disabled. Next step is to remove it (with the Vue3 refactor)
      loading: false,

      loadingStatus: {
        pagedWorkflows: {
          error: 0,
          target: 0,
          current: 0,
        },
      },
      failed: false,
      missingWorkflows: [],
      defaultFilter: 'actief',
    }
  },
  computed: {
    ...mapGetters('realisation', [
      'hasRecords',
      // 'loading',
      'records',
      'lastRefresh',
      'lastOpenedRecord',
    ]),
    ...mapGetters('user', [
      'canAccessRequests',
      'canAccessRealisationProcesses',
      'roleDetailsMerged',
    ]),
    ...mapGetters('tenant', [
      'isCurrentTenant',
    ]),
    mainRoute() {
      return ['RealisationList', 'RealisationListFiltered'].includes(this.$route.name)
    },
    filter() {
      return (this.$route.params.filter || this.defaultFilter).toLowerCase()
    },
    tableCategory() {
      return this.isCurrentTenant({ tenant: 'rvb' }) ? 'rvb' : 'realisation'
    },
    tableUuid() {
      return this.isGORAL
        ? '3406eb6e-f42a-4e9d-914a-5a11e308f867'
        : null
    },
    isGORAL() {
      return this.isCurrentTenant({ tenant: 'go-ral' })
    },

    usesPagedLoader() {
      return this.isCurrentTenant({ tenant: 'go-ral' })
        || this.isCurrentTenant({ tenant: 'park-n-charge' })
        || this.isCurrentTenant({ tenant: 'opcharge' })
        //|| this.isCurrentTenant({ tenant: 'vlaanderen' })
    },
  },
  watch: {
    /**
     * Replace active category filter
     */
    filter() {
      if (this.filter !== this.defaultFilter) {
        this.setCategoryFilterFromRoute()
      }
    },
  },
  created() {
    if (! this.canAccessRealisationProcesses) {
      this.$router.push({
        name: 'Dashboard',
      })
    }

    if (! this.hasRecords) {
      this.handleRefresh()
    }
  },
  mounted() {
    this.setCategoryFilterFromRoute()

    // Replace route to "actief" only initialy and if no route.filter exists (Alles)
    if (this.$route.name === 'RealisationList' && !this.$route.params.filter) {
      this.$router.replace({ path: '/realisatie/actief' })
    }
  },
  methods: {
    ...mapActions('realisation', [
      'loadRecords',
      'loadRecordsByCode',
      'loadProcessRecordsFromCBAPI',
    ]),
    ...mapMutations('realisation', [
      'setLoadingState',
    ]),
    ...mapMutations('relations', [
      'resetRelations',
      'addConnection',
    ]),
    getGeographyCodesAvailableToUser() {

      // Start with the municipality codes available to the Tenant
      let codes = municipalityOptions
            .filter(muni => muni.disabled === false)
            .map(muni => muni.value)

      // Then filter that list by checking whether the user has access
      if (! this.roleDetailsMerged.includes('*')) {
        codes = codes.filter(code => this.roleDetailsMerged.includes(code))
      }

      return codes
    },

    /**
     * TODO: This is a simple "happy path" implementation
     */
    handleRefresh: async function() {

      // Get the records the efficient way
      await this.loadProcessRecordsFromCBAPI({
        refresh: true,
        codes: this.getGeographyCodesAvailableToUser(),
      })

      // Update the RQ to RP relations
      this.matchRequestToRealisations()

    },

    handleRefreshOld: async function() {
      const token = await this.$auth.getTokenSilently()

      if (! this.usesPagedLoader) {
        await this.loadRecords({ token })
        this.matchRequestToRealisations()
      } else {

        this.setLoadingState({ loading: true })

        let codes = this.missingWorkflows.length
          ? this.missingWorkflows
          : municipalityOptions
            .filter(muni => muni.disabled === false)
            .map(muni => muni.value)

        if (! this.roleDetailsMerged.includes('*')) {
          codes = codes.filter(code => this.roleDetailsMerged.includes(code))
        }

        this.missingWorkflows = []
        this.loadingStatus.pagedWorkflows.error = 0
        this.loadingStatus.pagedWorkflows.target = codes.length

        await Promise.all(
          codes.map(code => {
            return this.loadRecordsByCode({ token, code })
              .then(() => {
                this.loadingStatus.pagedWorkflows.current++
              })
              .catch(() => {
                this.loadingStatus.pagedWorkflows.error++
                this.missingWorkflows.push(code)
              })
          }),
        )

        if (this.missingWorkflows.length === 0) {
          this.matchRequestToRealisations()
          this.setLoadingState({ loading: false })
          this.failed = false
        } else {
          this.failed = true
        }
      }
    },

    /**
     * Go through the realisation process objects and connect the request objects
     */
    matchRequestToRealisations() {
      if (! this.canAccessRequests && ! this.canAccessRealisationProcesses) return

      this.resetRelations()

      ;(this.records || []).forEach(record => {
        (record.requestUuids || []).forEach(uuid => {
          this.addConnection({
            requestUuid: uuid,
            realisationUuid: record.uuid,
          })
        })
      })
    },

    setCategoryFilterFromRoute() {
      if (! this.$refs.TableManager || ! this.mainRoute) return
      // console.log("setCatFilter")

      this.$refs.TableManager.replaceActiveFiltersInCategory({
        category: 'category',
        filters: [{ value: this.filter }],
      })
    },
  },
}
</script>

<style lang="scss">
.RealisationList {
  padding: 18px 0 30px;
}
</style>
